import { useMemo } from "react";

const useMeta = ({ isFetching, data, isFetchingNextPage }) => {
	return useMemo(() => {
		if (data?.pages) {
			return {
				loading: isFetching && !isFetchingNextPage,
				totalItems: data?.pages?.[0]?.count,
			};
		} else {
			return {
				loading: isFetching,
				totalItems: data?.count || 0,
			};
		}
	}, [data?.pages, data?.count, isFetching, isFetchingNextPage]);
};

const useData = ({ data }) => {
	return useMemo(() => {
		if (Array.isArray(data)) {
			return data;
		} else if (data?.items) {
			return data.items;
		} else if (data?.pages) {
			const pages = data?.pages?.map(page => page.items) || [];
			const allData = pages.flat();
			return allData;
		} else {
			return [];
		}
	}, [data]);
};

const useRefetch = ({ refetch }) => {
	return useMemo(() => {
		return refetch;
	}, [refetch]);
};

const useTableProps = queryResult => {
	const meta = useMeta(queryResult);
	const data = useData(queryResult);
	const refetch = useRefetch(queryResult);
	const fetchNextPage = queryResult.fetchNextPage;

	return {
		meta,
		data,
		refetch,
		fetchNextPage,
	};
};

export default useTableProps;
